module.exports = __webpack_public_path__ + "img/crate5.60c1d6c0.png";